const getMediaURLPrefix = () =>
  process.env.STRAPI_API_ENDPOINT?.replace('/graphql', '');
export default getMediaURLPrefix;
